import { Injectable } from '@angular/core';
import { Logger } from 'angular2-logger/core';
import { DashboardService } from './dashboard.service';
import { SharedService } from '../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { TreeNode } from 'primeng/api';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SocketioService {

  public rooms: any; // JUST THE CHAT INFO
  public dataReport : any;
  public states: any;
  public load: Observable<any>;
  loadSubject: Subject<any>;
  public currentBottom: any; 
  public currentP: any;
  public bottomState: any;
  public room_id: any;
  public msgs_init: any;
  public read_msg: boolean;
  public read_id: any;
  public current_route: any;

  public id_current: any;
  private _jsonURL = 'assets/files.json';
  constructor(
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    private logger: Logger,
    private activatedRoute: ActivatedRoute,
    public route: Router,
    private http: HttpClient
  ) {
    this.rooms = {};
    this.dataReport = {};
    this.currentBottom = 1;
    this.loadSubject = new Subject<any>();
    this.load = this.loadSubject.asObservable();
  }

  // activa el loader de espera
  loadState() {
    return this.load;
  }

  // devuelve estado actual de la página
  currentPage() { 
    return this.states;
  }

  // Evita el auto scroll una vez se pase de página
  stateInitial() {
    if (this.currentBottom !== this.currentP) {
      this.bottomState = 10;
      this.currentBottom = this.currentP;
      return this.bottomState;
    } else {
      return this.bottomState = 0;
    }
  }

  roomId() {
    return this.room_id;
  }

  getFirst() {

  }


  // Handler to initialize room and get all the previus messages, and save it into our "room" variable.
  getRoomMsgs(room_id: number | string) { 
    console.log("Acá es getRoomMsgs en socket Service: ", room_id);

    this.room_id = room_id;
    this.loadSubject.next(true);

    let data = { 
      auth_token: this._sharedService.getCookie('auth_token'),
      room_id: room_id,
    };

    let data2 = {
      id_room: room_id,
    };

    let route_id = this.route.parseUrl(this.route.url);

    if (route_id.root.children.primary.segments[5]) {
      this.id_current = route_id.root.children.primary.segments[5].path;
    } else {
      this.id_current = this.room_id;
    }

    let room_id_str = room_id.toString();
    if (this.id_current === room_id_str) {

      this._dashboardService.newMsgs(data2).subscribe(
        data => {
          //console.log(data);

          if (data.message === 'All room messages have changed to read.' || this.id_current === room_id_str) {
            return this.read_msg = true;
          }
          return this.read_msg = false;
        });
    }

    this._dashboardService.getRoomMsgs(data).subscribe(
      data => {

        if (data.status) {
          this.logger.log("received history:"); 
          this.logger.log(data);

          if(data.data) {
            this.currentP = data.data.current_page;
            if (!this.rooms[room_id])
              this.rooms[room_id] = {};

            if (!this.rooms[room_id].msgs) {
              this.rooms[room_id].msgs = [];
            }

            if (this.rooms[room_id].msgs.length === 0) {
              this.rooms[room_id].msgs = data.data.data;
              this.msgs_init = data.data.data;
              this.dataReport = data.data.dataReport; 
            } else {
              const existingMessages = this.rooms[room_id].msgs;
              const newMessages = data.data.data;
              const uniqueMessages = newMessages.filter(msg => 
                  !existingMessages.some(existingMsg => existingMsg.id === msg.id)
              );

              this.rooms[room_id].msgs.push(...uniqueMessages);
              this.dataReport = data.data.dataReport; 
            }

            this.loadSubject.next(false);   

            this.states = {
              currentPage: this.rooms[room_id].current_page = data.data.current_page,
              lastPage: this.rooms[room_id].current_page = data.data.last_page
            };
          }
          //   }

        } else {
          //this.load = false;
          
          this.loadSubject.next(false); // Acá va el mensaje de que no tengo permiso
          this.logger.log(data.message);
        }

      },
      error => {
        console.log("Justo antes");
        this.logger.log(error);

      }
    );
  }

  getFiles() {
    return this.http.get<any>('assets/files.json')
        .toPromise()
        .then(res => <TreeNode[]>res.data);
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/socketio.service.ts